export default __webpack_public_path__ + "static/teste-automatizado-1b170c7a0c7883ce8c37c31369b9c350.png";